import React, { useRef } from 'react';
import { useWavePainter } from '../hooks/useWavePainter.js';

export function VoiceConsole({
  listening,
  loading,
  speaker,
  micLevel,
  canUseVoice,
  onStartVoice,
  onStopVoice,
  onSwitchToText
}) {
  const canvasRef = useRef(null);
  useWavePainter(canvasRef, speaker, listening || loading, micLevel);

  return React.createElement(
    'section',
    { className: 'voice-console' },
    React.createElement('canvas', { ref: canvasRef, className: 'voice-wave', width: 1000, height: 170 }),
    React.createElement(
      'div',
      { className: 'voice-controls' },
      React.createElement(
        'button',
        {
          type: 'button',
          className: listening ? 'voice-btn danger' : 'voice-btn',
          disabled: loading || !canUseVoice,
          onClick: listening ? onStopVoice : onStartVoice
        },
        listening ? 'Stop Listening' : 'Start Voice'
      ),
      React.createElement(
        'span',
        { className: 'voice-state ' + speaker },
        speaker === 'user'
          ? 'You speaking'
          : speaker === 'sigmund'
            ? 'Sigmund speaking'
            : listening
              ? 'Listening'
              : 'Idle'
      ),
      React.createElement(
        'button',
        { type: 'button', className: 'switch-link', onClick: onSwitchToText },
        'Switch to Text'
      )
    )
  );
}
